import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import * as dd from 'dingtalk-jsapi';
import {TranslateService} from '@ngx-translate/core'; // 引入钉钉jsapi

@Component({
	selector: 'org-select-modal',
	templateUrl: './org-select-modal.component.html',
	styleUrls: ['./org-select-modal.component.scss'],
})
export class OrgSelectModalComponent implements OnInit {
  queryCriterias = [];
  selectedOrg;
  selectedOrgId;
  parentId;
  parentOrg;
  type;

  searchMessage = null;
  optionList = [];
  queryCompany;

	constructor(
		public dataService: DataService,
		public appService: AppService,
		public router: Router,
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalController: ModalController,
    public localStorageService: LocalStorageService,
        public translateService: TranslateService
  ) {
		let params = this.navParams.data;
    this.parentOrg = params.org;
    this.parentId = this.parentOrg ? this.parentOrg.id : null;
    this.type = params.type;
    this.queryCompany = params.queryCompany;
    this.selectedOrg = params.selectedOrg;
    this.getOrg();
	}

	ngOnInit() {
		// 设置标题
		document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.org_select_modal.choose_organization_structure');
	}

  getOrg() {
    if (this.queryCompany && this.type === 'bl') {
      this.dataService.queryOrgCompany(this.searchMessage, this.parentId, null).subscribe(res => {
        if (res && res['STATUS'] === 0) {
          this.optionList = res['DATA'];
        }
      })
    } else {
      this.dataService.queryOrg(this.searchMessage, this.parentId, null).subscribe(res => {
        if (res && res['STATUS'] === 0) {
          this.optionList = res['DATA'];
        }
      })
    }
  }

  markSelected(org) {
    this.selectedOrg = org;
    this.confirm();
  }

  isSelected(org) {
    if (this.selectedOrg && org.id === this.selectedOrg.id) {
      return true;
    }
    return false;
  }

	cancel() {
		this.modalController.dismiss();
	}

	confirm() {
		this.modalController.dismiss({ org: this.selectedOrg });
	}
}
